import { connect } from 'react-redux';

import { Entities, fetchAll, getEntities, patch, save } from 'src/common/index';
import CancellationOptionAdministration from 'src/components/admin/cancellations/cancellation-options-administration';

const mapStateToProps = state => {
    return {
        cancellationOptions: getEntities(state, Entities.CANCELLATION_OPTIONS),
    };
};

const CancellationOptionAdministrationContainer = connect(mapStateToProps, { fetchAll, patch, save })(
    CancellationOptionAdministration,
);

export default CancellationOptionAdministrationContainer;
